import { environment } from '../../../environments/environment';

export class ApiLinks {
  readonly baseUrl = environment.baseUrl;

  readonly baseUrlForSystemMandeep = environment.baseUrlForSystemMandeep;

  readonly admin_login = this.baseUrl + 'users/authenticate';

  readonly editAgent = this.baseUrl + 'customer/approve-agent/';

  // readonly wl_login = this.baseUrlForSystemMandeep + 'wl-account/authenticate'; //system mandeep

  readonly getAllPlansOFWL = this.baseUrl + 'plans/all'; // WL

  readonly getAllAssignPlans = this.baseUrl + 'plans/all/'; // WL

  readonly createPlan = this.baseUrl + 'plans/create'; //WL

  readonly uploadPricing = this.baseUrl + 'plans/uploadPricing'; //WL

  readonly updatePlan = this.baseUrl + 'plans/update'; //WL

  readonly getPlanById = this.baseUrl + 'plans/'; // WL

  readonly deletePlanById = this.baseUrl + 'plans/delete/'; //WL

  readonly getAllCoupons = this.baseUrl + 'coupon/all'; //WL

  readonly deleteCoupon = this.baseUrl + 'coupon/delete/'; //WL

  readonly createCoupon = this.baseUrl + 'coupon/generate'; //WL

  readonly wlEsimOrdersList = this.baseUrl + 'orders/esims';

  readonly wlRechargeOrdersList = this.baseUrl + 'orders/recharge';

  readonly allCustomers = this.baseUrl + 'customer/all/pagination';

  // readonly allAgents = this.baseUrl + 'customer/all';

  readonly addBalance = this.baseUrl + 'customer/';

  readonly deductBalance = this.baseUrl + 'customer/';

  readonly customerOrderHistoryById = this.baseUrl + 'orders/esims/';

  readonly walletHistory = this.baseUrl + 'wallet-history/admin/all';

  readonly walletHistoryById = this.baseUrl + 'wallet-history/customer/';

  readonly addFaq = this.baseUrl + 'faq/add';

  readonly allFaq = this.baseUrl + 'faq/all';

  readonly updateFaq = this.baseUrl + 'faq/update';

  readonly getFaqById = this.baseUrl + 'faq/';

  readonly deleteFaq = this.baseUrl + 'faq/';

  readonly contactDetail = this.baseUrl + 'contact';

  readonly planSync = this.baseUrl + 'plans/sycnc';

  readonly emailSetup = this.baseUrl + 'mail';

  readonly updateGeneralSettings = this.baseUrl + 'general-settings/';
  readonly generalSettings = this.baseUrl + 'general-settings';

  readonly changePass =
    this.baseUrlForSystemMandeep + 'wl-account/change-password';

  // readonly verifyUser =
  //   this.baseUrlForSystemMandeep + 'wl-account/forgot-passsword/';

  readonly requestOtpForPasswordReset = this.baseUrl + 'users/request/otp';

  readonly verifyOtpAndResetPassword =
    this.baseUrl + 'users/verify/reset/password';

  // readonly forgetPass =
  //   this.baseUrlForSystemMandeep + 'wl-account/verifyotp-updatepassword';

  readonly createMobileDevice = this.baseUrl + 'devices/create';

  readonly allMobileDevice = this.baseUrl + 'devices/all';

  // readonly walletDetails = this.baseUrlForSystemMandeep + 'wallet';

  readonly walletDetails = this.baseUrl + 'admin/wallet';

  readonly initiateRefund = this.baseUrl + 'refund/initiate';

  readonly refundList = this.baseUrl + 'refund/list';

  readonly refundRequestList = this.baseUrl + 'refund/request/list';

  readonly refundRequest = this.baseUrl + 'refund/customer/request';

  readonly approveRefundRequest = this.baseUrl + 'refund/request/approve/';

  readonly accountingReport = this.baseUrl + 'report/sync/accounting-report';

  readonly purchaseEsim = this.baseUrl + 'admin/purchase-plan';

  readonly esimDetails = this.baseUrl + 'admin/esim-details';

  readonly alleSimList = this.baseUrl + 'admin/recharge/eSim/list';

  readonly rechargeEsimCountryByIccid = this.baseUrl + 'admin/recharge/data';

  readonly rechargeEsimDataByCountryIccid =
    this.baseUrl + 'admin/recharge/country';

  readonly rechargeEsimPackages = this.baseUrl + 'admin/recharge/packages';

  readonly rechargeEsimPackageswithout8943 =
    this.baseUrl + 'admin/recharge/packages';

  readonly rechargeEsimByAdmin = this.baseUrl + 'admin/recharge-esim';

  readonly customerDetailsByIccid = this.baseUrl + 'admin/getCustomerByIccid/';

  readonly activateSim = this.baseUrl + 'sim-activation/activate';

  readonly validateSim = this.baseUrl + 'sim-activation/validate/';

  readonly allModules = this.baseUrl + 'roles/allModules';

  readonly createRoles = this.baseUrl + 'roles';

  readonly roles = this.baseUrl + 'roles';

  readonly rolesPermissions = this.baseUrl + 'roles/permissions';

  readonly updateRoles = this.baseUrl + 'roles/';

  readonly getRoleById = this.baseUrl + 'roles/';

  readonly createUser = this.baseUrl + 'users/create';

  readonly createAgent = this.baseUrl + 'customer/create/agent';

  readonly deleteUser = this.baseUrl + 'users/delete/';

  readonly allUsers = this.baseUrl + 'users/all';

  readonly updateUsers = this.baseUrl + 'users/update/';

  // readonly user_authenticate = this.baseUrl + 'users/authenticate';

  readonly wl_login = this.baseUrl + 'users/authenticate';
}
